// extracted by mini-css-extract-plugin
export var infoItem = "_l8-1";
export var title = "_l8-0";